var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-view", attrs: { id: "verify-tree-grid" } },
    [
      _c(
        "cargo-up-down-resize",
        {
          staticClass: "app-main-inner section",
          staticStyle: { height: "100%" },
          attrs: {
            "up-style": {
              display: "flex",
              flexDirection: "column",
              paddingBottom: "5px"
            },
            "down-style": {
              display: "flex",
              flexDirection: "column",
              paddingTop: "5px"
            },
            "show-up": _vm.showAr
          }
        },
        [
          _c(
            "template",
            { slot: "up" },
            [
              _c(
                "div",
                { staticStyle: { "align-items": "center", display: "flex" } },
                [
                  _c("div", {}, [
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Receivable")))
                    ])
                  ]),
                  _c(
                    "div",
                    { staticStyle: { "padding-left": "5px" } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            id: "btnAdd1",
                            type: "primary",
                            disabled: !_vm.isEditing
                          },
                          on: { click: _vm.addCost }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("FinanceManage.charge_add")) + " "
                          )
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            id: "btnDelete1",
                            type: "danger",
                            disabled: !_vm.isEditing
                          },
                          on: {
                            click: function($event) {
                              return _vm.deleteCost()
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("FinanceManage.charge_delete")) + " "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ]
              ),
              _c("cargo-ag-grid", {
                ref: "arGrid",
                staticStyle: { "padding-top": "5px" },
                attrs: {
                  "grid-options": _vm.ar.gridOptions,
                  "column-defs": _vm.ar.columnDefs,
                  "config-module": "250319",
                  "row-data": _vm.ar.rowData
                },
                on: {
                  gridReady: function(p) {
                    _vm.ar.gridApi = p.api
                  }
                }
              })
            ],
            1
          ),
          _c(
            "template",
            { slot: "down" },
            [
              _c(
                "div",
                { staticStyle: { display: "flex", "align-items": "center" } },
                [
                  _c("div", [
                    _c("span", [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Dues")))])
                  ]),
                  _c(
                    "div",
                    { staticStyle: { "padding-left": "5px" } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            id: "btnAdd1",
                            type: "primary",
                            disabled: !_vm.isEditing
                          },
                          on: { click: _vm.addSelling }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("FinanceManage.charge_add")) + " "
                          )
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            id: "btnDelete1",
                            type: "danger",
                            disabled: !_vm.isEditing
                          },
                          on: { click: _vm.deleteSelling }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("FinanceManage.charge_delete")) + " "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ]
              ),
              _c("cargo-ag-grid", {
                ref: "apGrid",
                staticStyle: { "padding-top": "5px" },
                attrs: {
                  "grid-options": _vm.ap.gridOptions,
                  "column-defs": _vm.ap.columnDefs,
                  "config-module": "250320",
                  "row-data": _vm.ap.rowData
                },
                on: {
                  gridReady: function(p) {
                    _vm.ap.gridApi = p.api
                  }
                }
              })
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }